import { useLocation } from "react-router-dom";

export const useIsIframeMode = () => {
  const location = useLocation();
  const isIframeMode = new URLSearchParams(location.search).has("iframe");

  return { isIframeMode };
};
